import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { incrementTimeByElapsedSeconds } from 'app/shared/utility/cycle-time';
import { interval } from 'rxjs';

@Component({
  selector: 'app-cycle-time',
  templateUrl: './cycle-time.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CycleTimeComponent implements OnInit {
  @Input() public time!: string;
  @Input() public autoIncrement = true;
  public formattedTime!: string;
  public formattedTitle!: string;

  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private elapsedSeconds = 0;

  public ngOnInit(): void {
    interval(1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this.time && this.autoIncrement) {
          const { title, value } = incrementTimeByElapsedSeconds(this.time, this.elapsedSeconds);

          this.formattedTime = value;
          this.formattedTitle = title;
          this.cdr.detectChanges();
        }
        this.elapsedSeconds = this.elapsedSeconds + 1;
      });

    if (!this.autoIncrement && this.time) {
      this.updateTime(this.time, 0);
      this.cdr.detectChanges();
    }
  }

  private updateTime(time: string, elapsed: number): void {
    const { title, value } = incrementTimeByElapsedSeconds(time, elapsed);

    this.formattedTime = value;
    this.formattedTitle = title;
    this.cdr.detectChanges();
  }
}
